import { useEffect, useState } from "react"

import { GROUP } from "@shared/config"
import { useSchedule, Viewer } from "@shared/contexts"
import { getRef } from "@shared/modules"
import { viewerService } from "@shared/services"

interface ReturnProps {
  managers: Viewer[]
  viewers: Viewer[]
}

export default function useViewers(): ReturnProps {
  const { schedule } = useSchedule()
  const [managers, setManagers] = useState<Viewer[]>([])
  const [viewers, setViewers] = useState<Viewer[]>([])

  const scheduleKey = schedule?.key

  useEffect(() => {
    if (!scheduleKey) return

    const viewersRef = getRef("viewers").child(scheduleKey)

    const onValue = (snapshot: firebase.database.DataSnapshot) => {
      const firebaseViewers = snapshot.val()

      if (!firebaseViewers) {
        setManagers([])
        setViewers([])
        return
      }

      let viewers: Viewer[] = []

      Object.keys(firebaseViewers).forEach((key: any) => {
        if (!firebaseViewers[key].nickname) return

        viewers.push(viewerService.toCamelCase(firebaseViewers[key]))
      })

      setManagers(
        viewers
          .filter((viewer: Viewer) => GROUP.STREAMER.includes(viewer.role))
          .sort((pv: Viewer, nv: Viewer) => (pv.role > nv.role ? -1 : 1)),
      )

      setViewers(
        viewers.filter(
          (viewer: Viewer) => !GROUP.STREAMER.includes(viewer.role),
        ),
      )
    }

    viewersRef.on("value", onValue)

    return () => {
      viewersRef.off("value", onValue)
    }
  }, [scheduleKey])

  return { viewers, managers }
}
